import NonsupportI18n from './src/NonsupportI18n.vue'

NonsupportI18n.install = function (Vue) {
  Vue.component(NonsupportI18n.name, NonsupportI18n)
}

export default NonsupportI18n
